/**
 * InAppMessaging
 * Orchestrator for server-driven in-app messages.
 * Renders at the app root level — shows one message at a time (highest priority first).
 * Delegates to the appropriate display component based on message.displayType.
 */

import React from 'react';
import { useMessageStore, selectCurrentMessage } from '../../store/messageStore';
import { MessageBanner } from './MessageBanner';
import { MessageModal } from './MessageModal';
import { ForceUpdateOverlay } from './ForceUpdateOverlay';

export function InAppMessaging() {
  const message = useMessageStore(selectCurrentMessage);

  if (!message) return null;

  switch (message.displayType) {
    case 'banner':
      return <MessageBanner message={message} />;
    case 'modal':
      return <MessageModal message={message} />;
    case 'blocking':
      return <ForceUpdateOverlay message={message} />;
    default:
      return null;
  }
}
